import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';

import { Button, Col, DatePicker, Dropdown, Input, Menu, Row, Select } from 'antd';
import Title from 'antd/es/typography/Title';
import { getOnlyOrgView as getEmployees, getSelectBoxWorkCheckInStatusActivities, getSelectBoxWorkPriorityLevel, getSelectBoxWorkStatusActivities } from 'app/entities/common/common.reducer';
import { setFilterActivities } from 'app/entities/filters/filters.reducer';
import { getAllReportSchedule } from 'app/entities/report-schedule/report-schedule.reducer';
import TableComponent from 'app/shared/component/table/table';
import { OrderByType } from 'app/shared/model/enum/order-type.enum';
import { filterOption } from 'app/shared/util/select-filter';
import * as _ from 'lodash';
import { ReactSVG } from 'react-svg';
import { getActivitiesCheckIn } from '../activities.reducer';
import ReportActivities from '../form/report/form/reportActivities';
import ReportActivitiesResult from '../form/report/view/reportActivitiesResult';
import { columnsCheckIn } from './config';
import FilterModal from './filter/filter';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';

const { Search } = Input;
const { RangePicker } = DatePicker;

export const ActivitiesCheckIn = () => {
  const dispatch = useAppDispatch();
  const pageLocation = useLocation();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const activitiesList = useAppSelector(state => state.activities.entities);
  const reportScheduleList = useAppSelector(state => state.reportSchedule.entities);
  const totalRecord = useAppSelector(state => state.activities.totalItems);
  const priorityLevelList = useAppSelector(state => state.common.priorityLevel);
  const workStatusActivitiesList = useAppSelector(state => state.common.workStatusActivities);
  const checkInStatusActivitiesList = useAppSelector(state => state.common.checkInStatusActivities);
  const filters = useAppSelector(state => state.filters.activities);

  const [idSelected, setIdSelected] = useState(null);
  const [visibleFilter, setFilterModalVisible] = useState(false);
  const [visibleModalReport, setVisibleModalReport] = useState(false);
  const [visibleModalReportResult, setVisibleModalReportResult] = useState(false);

  const [searchText, setSearchText] = useState();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [checkedList, setCheckedList] = useState<string[]>([]);
  const [columnConfig, setColumnConfig] = useState<any[]>([]);
  const employeeList = useAppSelector(state => state.common.orgsView);
  const [selectedRowKeys, setSelectedRowKeys] = useState([])

  const newColumns = columnConfig.map(item => ({
    ...item,
    hidden: !checkedList.includes(item.key),
  }));

  useEffect(() => {
    if (employeeList && employeeList.length > 0 && !filters?.accountableId) {
      handleChangeEmployee(filters?.accountableId ?? employeeList[0].id)
    }
  }, [employeeList])

  useEffect(() => {
    setCheckedList(_.uniq([...checkedList, ...[...columnsCheckIn].map(x => {
      if (x.defaultShow) {
        return x.key
      }
    }
    )]));
  }, []);

  useEffect(() => {
    setColumnConfig(createColumns());
  }, [checkedList]);

  useEffect(() => {
    getAllEntities();
  }, [paginationState.activePage, paginationState.itemsPerPage, paginationState.sort, filters]);

  useEffect(() => {
    dispatch(getAllReportSchedule());
    dispatch(getEmployees());
    dispatch(getSelectBoxWorkPriorityLevel())
    dispatch(getSelectBoxWorkStatusActivities())
    dispatch(getSelectBoxWorkCheckInStatusActivities())
  }, []);

  const createColumns = () => {
    return [...columnsCheckIn];
  };

  const getAllEntities = (value?: string) => {
    if (filters?.accountableId) {
      dispatch(
        getActivitiesCheckIn({
          searchText: value ?? searchText,
          page: paginationState.activePage,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
          pic: filters?.pic,
          accountableId: filters?.accountableId,
          dueDate: filters?.dueDate && filters.dueDate,
          field: filters?.field,
          alignId: filters?.alignId,
          reportScheduleId: filters?.reportScheduleId,
          projectId: filters?.projectId,
          startDate: filters?.startDate && filters.startDate,
          workPriorityLevel: filters?.workPriorityLevel,
          workStatus: filters?.workStatus,
          workTypeId: filters?.workTypeId,
          activityCheckinStatus: filters?.activityCheckinStatus ?? 3
        }),
      );
    }
  };

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    const { order, sort } = paginationState;
    setPaginationState({
      ...paginationState,
      order: Object.keys(sorter).length !== 0 ? (sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC) : order,
      sort: Object.keys(sorter).length !== 0 ? sorter.columnKey : sort,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleFreeTextSearchQuery = query => {
    setSearchText(query);
    getAllEntities(query);
  };

  const getAllRowKeys = item => {
    return item.reduce((keys, value) => {
      keys.push(value.code);

      if (value.keyResults) {
        keys = keys.concat(getAllRowKeys(value.keyResults));
      }

      return keys;
    }, []);
  };

  const handleUpdateReport = item => {
    setIdSelected(item.activityId);
    setVisibleModalReport(true);
  };

  const handleCloseModalReportActivities = (isReload = false) => {
    setIdSelected(null);
    setVisibleModalReport(false);
    if (isReload) {
      getAllEntities();
    }
  };

  const handleViewReportResult = item => {
    setIdSelected(item.activityId);
    setVisibleModalReportResult(true);
  };

  const handleCloseModalReportActivitiesResult = () => {
    setIdSelected(null);
    setVisibleModalReportResult(false);
  };

  const handleRowClick = (event, record) => {
    event.preventDefault();
    handleUpdateReport(record)
  };

  const handleChangeEmployee = (value: string) => {
    const employee = _.find(employeeList, o => o.id === value);
    dispatch(
      setFilterActivities({
        ...filters,
        accountableId: value,
        accountableName: employee?.name,
      }),
    );
  };

  const handleChangeReportSchedule = (value: string) => {
    dispatch(
      setFilterActivities({
        ...filters,
        reportScheduleId: value,
      }),
    );
  };

  const handleChangeActivitiesStatus = (value: string) => {
    dispatch(
      setFilterActivities({
        ...filters,
        workStatus: value,
      }),
    );
  };

  const handleChangeCheckInActivitiesStatus = (value: string) => {
    dispatch(
      setFilterActivities({
        ...filters,
        activityCheckinStatus: value,
      }),
    );
  };

  const handleChangePriority = (value: string) => {
    dispatch(
      setFilterActivities({
        ...filters,
        workPriorityLevel: value,
      }),
    );
  };

  const rowSelection = {
    selectedRowKeys,
    onChange(newSelectedRowKeys) {
      setSelectedRowKeys(newSelectedRowKeys);
    },
    getCheckboxProps: () => ({
      disabled: true // Disable checkbox for row with key 1
    }),
  };

  const handleChangeRangeDate = (dateRanges: any) => {
    const fromDate = dateRanges[0] && dateRanges[0].format(APP_LOCAL_DATE_FORMAT_PAYLOAD);
    const toDate = dateRanges[1] && dateRanges[1].format(APP_LOCAL_DATE_FORMAT_PAYLOAD);
    dispatch(
      setFilterActivities({
        ...filters,
        startDate: fromDate,
        dueDate: toDate,
      }),
    );
  }

  return (
    <Container className="view">
      <div className="d-flex gap-5 mt-2">
        <Row className="d-flex justify-content-between w-100">
          <Col md={20}>
            <Row>
              <Col md={16}>
                <Title level={3}>{`Check in CV ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
              </Col>
            </Row>
          </Col>
          <Col md={4}>
            <Select
              className="w-100"
              filterOption={filterOption}
              onChange={handleChangeEmployee}
              value={filters?.accountableId}
              showSearch
              size="large"
              options={employeeList.map(x => {
                return {
                  label: x.name,
                  value: x.id,
                };
              })}
            />

          </Col>
        </Row>
      </div>

      <div className="table">
        <div className="header">
          <Col md={24}>
            <Row className='w-100 d-flex gap-3'>
              <Col md={3}>
                <Select
                  className="w-100"
                  value={filters?.reportScheduleId}
                  showSearch
                  options={reportScheduleList.map(x => {
                    return {
                      value: x.id,
                      label: x.name,
                    };
                  })}
                  onChange={handleChangeReportSchedule}
                  filterOption={filterOption}
                  placeholder="Chọn kỳ báo cáo"
                  size="large"
                />
              </Col>
              <Col md={3}>
                <Select
                  className="w-100"
                  defaultValue={3}
                  value={filters?.workStatus}
                  options={checkInStatusActivitiesList}
                  onChange={handleChangeCheckInActivitiesStatus}
                  filterOption={filterOption}
                  size="large"
                />
              </Col>
              <Col md={3}>
                <Select
                  className="w-100"
                  defaultValue={null}
                  value={filters?.workStatus}
                  options={[{ label: "Tình trạng CV: tất cả", value: null }, ...workStatusActivitiesList]}
                  onChange={handleChangeActivitiesStatus}
                  filterOption={filterOption}
                  placeholder="Chọn tình trạng cv"
                  size="large"
                />
              </Col>
              <Col md={3}>
                <Select
                  className="w-100"
                  value={filters?.workPriorityLevel}
                  defaultValue={null}
                  onChange={handleChangePriority}
                  options={[{ label: "Mức độ ưu tiên: tất cả", value: null }, ...priorityLevelList]}
                  filterOption={filterOption}
                  placeholder="Chọn mức độ ưu tiên"
                  size="large"
                />
              </Col>
              <Col md={4}>
                <RangePicker onChange={handleChangeRangeDate} placeholder={['Từ ngày', 'Đến ngày']} format={APP_LOCAL_DATE_FORMAT} size='large' />
              </Col>
              <Col md={5}>
                <Search size="large" className='w-100' allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
              </Col>
              <Col md={1}>
                <Button
                  className={`filter primary ${(filters?.alignId ||
                    filters?.fieldValue ||
                    filters?.projectId ||
                    filters?.workStatus ||
                    filters?.workTypeId ||
                    filters?.fromDate ||
                    filters?.toDate) ? 'active-filter' : ''}`}
                  size="large"
                  onClick={() => {
                    setFilterModalVisible(true);
                  }}
                  icon={<ReactSVG src={'content/images/icons/filter.svg'} />}
                />
              </Col>
            </Row>
          </Col>
        </div>
      </div>
      <TableComponent
        rowSelection={rowSelection}
        data={activitiesList.map((x, index) => {
          return {
            key: index + 1,
            ...x,
          };
        })}
        scroll={true}
        total={totalRecord}
        isFetching={false}
        columns={newColumns}
        tableLayout="fixed"
        handleRowClick={(event, record) => { handleRowClick(event, record) }}
        expandedRowKeys={expandedRowKeys}
        setExpandedRowKeys={setExpandedRowKeys}
        handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
          handleChange(pageNumber, size, sorter);
        }}
      />
      {visibleModalReportResult && (
        <ReportActivitiesResult
          isOpen={visibleModalReportResult}
          idSelected={idSelected}
          onClose={handleCloseModalReportActivitiesResult}
        />
      )}
      {visibleModalReport && (
        <ReportActivities isOpen={visibleModalReport} idSelected={idSelected} onClose={handleCloseModalReportActivities} />
      )}
      {visibleFilter && (
        <FilterModal visible={visibleFilter} onCancel={() => setFilterModalVisible(false)} />
      )}
    </Container>
  );
};

export default ActivitiesCheckIn;
